import { render } from "./Done.vue?vue&type=template&id=be0b9026&scoped=true&ts=true"
import script from "./Done.vue?vue&type=script&lang=ts"
export * from "./Done.vue?vue&type=script&lang=ts"

import "./Done.vue?vue&type=style&index=0&id=be0b9026&lang=scss&scoped=true"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be0b9026"]])

export default __exports__